export default "__VITE_ASSET__BjQ2fX8u__"